import "react-tagsinput/react-tagsinput.css";

import React from "react";
import ReactTagsInput from "react-tagsinput";

import { FieldProps } from "formik";
import cx from "clsx";

export interface InputProps extends FieldProps {
  label?: string;
  placeholder?: string;
  htmlType?: string;
  type?: string;
}

export default ({ label, placeholder, htmlType = "text", type = "text", field, form, ...rest }: InputProps) => {
  const touched = form.touched[field.name];
  const error = form.errors[field.name];

  const inputClasses = cx("form-control", {
    "is-invalid": touched && error,
    "is-valid": touched && !error
  });
  const feedbackClasses = cx({
    "invalid-feedback": touched && error,
    "valid-feedback": touched && !error
  });

  const renderComponent = () => (
    <ReactTagsInput
      inputProps={{ placeholder: "" }}
      {...field}
      onChange={tags => form.setFieldValue(field.name, tags)}
    />
  );

  return (
    <div className="form-group">
      {label && <label className="control-label">{label}</label>}
      {renderComponent()}
      {touched && error && <div className={feedbackClasses}>{error}</div>}
    </div>
  );
};
